import type { ReactNode } from 'react';
import { PageContainer } from '../PageContainer/PageContainer';

export type GalleryTemplateProps = {
  /** A PageHeader. */
  header: ReactNode;
  /** Category or style FilterChips (selected in ink). */
  filters?: ReactNode;
  /** One featured item above the grid (a large ArticleCard). */
  featured?: ReactNode;
  /** The grid of cards. */
  children: ReactNode;
  /** A CtaBand holding the page's one primary action (CV templates: into CV Studio). */
  cta?: ReactNode;
  className?: string;
};

/**
 * Card galleries: the resources hub (ResourceHubTemplate) and the CV templates gallery
 * (CvTemplatesTemplate). Downloads on template cards are secondary: they are not the page's action.
 */
export function GalleryTemplate({ header, filters, featured, children, cta, className }: GalleryTemplateProps) {
  return (
    <PageContainer className={className}>
      <div className="flex flex-col gap-jc-block py-jc-section">
        {header}
        {filters ? <div className="flex flex-wrap gap-2">{filters}</div> : null}
        {featured}
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">{children}</div>
        {cta}
      </div>
    </PageContainer>
  );
}

/** Resources hub (/resources, /tyoelama, /arbetsliv, research indexes, feature hubs). */
export const ResourceHubTemplate = GalleryTemplate;
/** CV templates gallery (cv-template-finland, cv-pohja, cv-mall, letters). */
export const CvTemplatesTemplate = GalleryTemplate;
